/* global axios */
import ApiClient from '../../ApiClient';
import ContactsAPI from '../../contacts';

class VoiceAPI extends ApiClient {
  constructor() {
    super('voice', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  initiateCall(contactId, inboxId, webrtcPayload) {
    return ContactsAPI.initiateCall(contactId, inboxId, webrtcPayload).then(
      r => r.data
    );
  }

  leaveConference(inboxId, conversationId) {
    return axios
      .delete(`${this.baseUrl()}/inboxes/${inboxId}/conference`, {
        params: { conversation_id: conversationId },
      })
      .then(r => r.data);
  }

  joinConference({ conversationId, inboxId, callSid }) {
    return axios
      .post(`${this.baseUrl()}/inboxes/${inboxId}/conference`, {
        conversation_id: conversationId,
        call_sid: callSid,
      })
      .then(r => r.data);
  }

  getToken(inboxId) {
    if (!inboxId) return Promise.reject(new Error('Inbox ID is required'));
    return axios
      .get(`${this.baseUrl()}/inboxes/${inboxId}/conference/token`)
      .then(r => r.data);
  }

  answerWhatsappCall({ conversationId, inboxId, callSid, sdp }) {
    return axios
      .post(
        `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_calls/${callSid}/answer`,
        {
          conversation_id: conversationId,
          sdp: sdp,
        }
      )
      .then(r => r.data);
  }

  rejectWhatsappCall({ inboxId, callSid }) {
    return axios
      .post(
        `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_calls/${callSid}/reject`
      )
      .then(r => r.data);
  }

  terminateWhatsappCall({ inboxId, callSid }) {
    return axios
      .post(
        `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_calls/${callSid}/terminate`
      )
      .then(r => r.data);
  }

  checkCallPermission({ inboxId, userWaId }) {
    return axios
      .get(
        `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_calls/check_permission`,
        {
          params: { user_wa_id: userWaId },
        }
      )
      .then(r => r.data);
  }

  requestCallPermission({ inboxId, userWaId, body }) {
    return axios
      .post(
        `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_calls/request_permission`,
        {
          user_wa_id: userWaId,
          body,
        }
      )
      .then(r => r.data);
  }
}

export default new VoiceAPI();
